import { ResetPassword } from "@/components/ResetPassword";

export const ActivateAccount = () => {
  return <ResetPassword resetRole="webUserActivation" />;
};
